import 'whatwg-fetch';
import Util from '../src/util';

declare var API_HOST: string;

export default class Auth {
    private _areaId: string = '';
    private _token: string = '';
    private _areaNameKanji?: string;
    private _areaNameEn?: string;
    private _authenticated: boolean = false;
    private _appId: string;
    private _authKey: string;
    private _partialKey: string = '';
    private _device: string;
    private _lat?: number;
    private _lng?: number;
    private _host: string;
    private _gcp_api_host: string;
    public  _subStations: string;  // 多チャンネル化対応

    constructor(appId: string, authKey: string) {
        this._appId = appId;
        this._authKey = authKey;
        this._device = Util.getDevice();
        this._host = typeof API_HOST === 'undefined' ? location.host : API_HOST;
        // UNYO-3266 暫定対応
        // 環境ごとにビルド成果物を分ける対応は別課題で対応し、今回は商用の設定で実装する
        // 別環境向けにビルドする時はこの値を編集する
        this._gcp_api_host = 'api-backup.radiko.jp';
    }

    private auth1() {
        let headers = new Headers({
            "X-Radiko-App": this._appId,
            "X-Radiko-App-Version": "0.0.1",
            "X-Radiko-User": "dummy_user",
            "X-Radiko-Device": this._device,
        });
        return fetch(
            `https://${this._gcp_api_host}/v2/api/auth1`,
            {
                headers: headers,
                method: "get",
                credentials: 'include'
            }
        )
            .catch(() => {
                console.log("auth1 error");
            });
    }

    private auth2() {
        let headers = new Headers({
            "X-Radiko-AuthToken": this._token,
            "X-Radiko-Partialkey": this._partialKey,  // key文字列は固定
            "X-Radiko-User": "dummy_user",
            "X-Radiko-Device": this._device,
        });

        if (this._lat && this._lng) {
            headers.append('X-Radiko-Location', `${this._lat},${this._lng},gps`);
            headers.append('X-Radiko-Connection', `mobile`);
        } else {
            // 緯度経度が取れなければIPアドレスで判定
            headers.append('X-Radiko-Connection', `wifi`);
        }

        return fetch(
            `https://${this._gcp_api_host}/v2/api/auth2`,
            {
                headers: headers,
                method: "get",
                credentials: 'include'
            }
        )
            .catch(() => {
                console.log("auth2 error");
            });
    }

    private static createPartialkey(buffer: ArrayBufferLike, offset: number, keyLength: number) {
        let view = new Uint8Array(buffer, offset, keyLength);

        let binary = '';
        for (let i = 0; i < view.length; i++) {
            binary += String.fromCharCode(view[i]);
        }

        return btoa(binary);
    }

    public get areaId() {
        return this._areaId;
    }

    public get areaNameKanji() {
        return this._areaNameKanji;
    }

    public get areaNameEn() {
        return this._areaNameEn;
    }

    public get authenticated() {
        return this._authenticated;
    }

    public get token() {
        return this._token;
    }

    // 多チャンネル化対応
    public get subStations() {
        return this._subStations;
    }

    public setPosition(lat: number, lng: number) {
        this._lat = lat;
        this._lng = lng;
    }

    public request() {
        return this.auth1()
            .then((res: any) => {
                const token = res.headers.get("x-radiko-authtoken");
                const offset = res.headers.get('x-radiko-keyoffset');
                const length = res.headers.get('x-radiko-keylength');

                if (token == null || offset == null || length == null) {
                    console.log('not found playlist_create_url');
                    return;
                }

                this._token = token;
                this._partialKey = Auth.createPartialkey(Util.str2Buffer(this._authKey), +offset, +length);
                return this.auth2();
            })
            .then((res: any) => {
                // 多チャンネル化対応
                if (res.headers.get("x-radiko-substation")) {
                    this._subStations = res.headers.get("x-radiko-substation");
                }

                return res.text();
            })
            .then((txt: string) => {
                txt = txt.trim();
                const [area_id, area_name_kanji, area_name_en] = txt.split(",");
                this._areaId = area_id;
                this._areaNameKanji = area_name_kanji;
                this._areaNameEn = area_name_en;
                this._authenticated = true;

                return true;
            });
    }
}
